import React from 'react';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { PapiGruserModuleWatching } from '@wix/da-papi-types';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '@wix/da-gruser-shared/pkg/components/WidgetBox';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import useModulePrivileges from '@wix/da-gruser-shared/pkg/hooks/useModulePrivileges';
import Supporters from '../Supporters';
import EmptyState from '../../../EmptyState';
import { getProfileOwner } from '../../../../selectors/users';
import { useSelector } from 'react-redux';

import s from './SupportersBox.scss';

interface Props {
  moduleId: number;
  widgetBoxProps?: Partial<WidgetBoxProps>;
}

const SupportersBox: React.FC<Props> = ({ moduleId, widgetBoxProps }) => {
  const { t } = useTranslation();
  const profileOwner = useSelector(getProfileOwner);

  const { moduleData } = useModuleData<PapiGruserModuleWatching>(moduleId);
  const modulePrivs = useModulePrivileges(moduleId);
  const isEmpty = !moduleData?.results.length;
  const isOwner = !modulePrivs?.edit;

  const navigateToSubmit = () => {
    window.location.replace(URLS.SUBMIT);
  };

  return (
    <WidgetBox
      header={t('widgets.supporters.header')}
      moduleId={moduleId}
      {...widgetBoxProps}
    >
      {!isEmpty ? (
        <Supporters moduleId={moduleId} />
      ) : isOwner ? (
        <EmptyState
          view="small"
          className={s['empty-state']}
          title={t('widgets.supporters.empty.title.owner')}
          subtitle={t('widgets.supporters.empty.subtitle.owner')}
          buttonLabel={t('widgets.supporters.empty.CTALabel.owner')}
          withButton={true}
          onButtonClick={navigateToSubmit}
        />
      ) : (
        <EmptyState
          view="small"
          className={s['empty-state']}
          title={t('widgets.supporters.empty.title.visitor')}
          subtitle={t('widgets.supporters.empty.subtitle.visitor', {
            username: profileOwner?.user?.username,
          })}
        />
      )}
    </WidgetBox>
  );
};
SupportersBox.displayName = 'SupportersBox';

export default SupportersBox;
